import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatSummary } from '@domain/models';
import { ChatStore } from '@application/chat.store';

@Component({
  selector: 'app-chat-preview',
  imports: [CommonModule],
  templateUrl: './chat-preview.component.html',
  styleUrl: './chat-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatPreviewComponent {
  chat = input.required<ChatSummary>();
  private chatStore = inject(ChatStore);

  readonly otherUser = computed(() => this.chatStore.otherUserOf(this.chat()));

  readonly messagePreview = computed(() => {
    let text = this.chat().lastMessagePreview || 'Aún no hay mensajes';
    if (text.length > 35) text = text.substring(0, 35) + '...';
    return text;
  });

  readonly relativeTime = computed(() => {
    const timestamp = this.chat().lastActivityAt;
    const diffMs = Date.now() - timestamp;
    const diffMin = Math.floor(diffMs / 60000);
    const diffH = Math.floor(diffMin / 60);
    const diffD = Math.floor(diffH / 24);
    if (diffMin < 1) return 'now';
    if (diffMin < 60) return `${diffMin}m`;
    if (diffH < 24) return `${diffH}h`;
    if (diffD < 7) return `${diffD}d`;
    return new Date(timestamp).toLocaleDateString('es-PE', { month: 'short', day: 'numeric' });
  });

  readonly formattedDate = computed(() => {
    return new Date(this.chat().lastActivityAt).toLocaleString();
  });

  readonly isUserOnline = computed(() => {
    const id = this.otherUser()?.id;
    return id != null ? id.charCodeAt(id.length - 1) % 2 === 0 : false;
  });
}
